<!--
Author: TangChen
Date: 2018-09-06
Desc: 设置登录后页面头部，为公共组件
 -->
<template>
    <div class="comp-header comp">
        <div v-if="login" class="tit-con">
            <div v-cloak class="container">
                <span>{{ "欢迎光临"+name+"!" }}</span>
                <div class="right">
                    <span class="like"><i class="el-icon-user font-grey"></i>{{ (info.custname?info.custname:(info.mobile?info.mobile:info.certificateno))+",您好！" }}</span>
                    <span class="like cursor" v-on:click.prevent="logoff">[安全退出]</span>
                    <span v-if="!$util.isEmpty(companyInfo.servicephone)" class="main bold">
                        <i class="el-icon-phone"></i>
                        {{ companyInfo.servicephone }}
                    </span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="header-box">
                <div class="logo">
                    <img v-if="companyInfo.companylogo" :src="$util.src('/common/download',{id:companyInfo.companylogo})" height="41" v-on:click.prevent="$router.push({name:'login'})">
                    <!-- <div v-if="tit" class="tit">
                        {{ tit }}
                    </div> -->
                </div>
                <ul v-if="!login" class="links">
                    <template v-if="links.length>0">
                        <li v-for="link in links" :key="link.n">
                            <a :href="link.u" target="_blank" :title="link.n">
                                <i :class="link.i" /> {{ link.n }}</a>
                        </li>
                    </template>
                </ul>
                <div v-else class="menu right">
                    <menu-con />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import menuCon from "@/components/frame/menu.vue";
export default {
    name: "HeaderCom",
    components: {
        menuCon
    },
    props: {
        tit: {
            type: String,
            default: ""
        }
    },
    data () {
        return {
            name: "",
            login: false,
            links: [],
            companyInfo: {},
            info: {}
        };
    },
    mounted () {
        this.info = this.$cache.getUser();
        this.companyInfo = this.$cache.getCompanyInfo();
        if (this.companyInfo && this.companyInfo.companyheardlink) {
            this.links = JSON.parse(this.companyInfo.companyheardlink);
            this.name = this.companyInfo.companyname;
            document.title = this.companyInfo.companyname || this.$route.meta.nameText;
        }
        this.login = this.$store.state.login.status;

    },
    methods: {
        logoff () {
            const _this = this;
            this.$util.request("common/logout", {}, false, false).then(res => {
                if (res.data) {
                    _this.$store.dispatch("logout", res.data[0]).then(() => {
                        _this.$router.replace("/");
                    });
                }
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-header {
    background-color: $bg2;
    min-width: 1200px;
    border-bottom: 3px solid $color-a;
    .tit-con{
        background-color: $bg1;
        height: 40px;
        line-height: 40px;
        color: $text-color7;
        .right>span{margin-left: 8px;&.cursor:hover{color: $color-b;}}
    }
    .container {
        position: relative;
        height: 100%;
        .header-box {
            height: 80px;
        }
        .logo {
            display: inline-block;
            padding-top: 20px;
            .tit {
                display: inline-block;
                color: $text-color1;
                font-size: $f22;
				min-width: 200px;
            }
            .tit:before {
                content: "";
                margin: 0 18px;
                border-left: 1px solid $border-color4;
            }
            img {
                // width: 195px;
                vertical-align: middle;
                height: 41px;
            }
        }
        .menu{outline: none;}
        .links {
            position: absolute;
            right: 0;
            top: 25px;
            font-size: 18px;
            li {
                display: inline-block;
                margin-left: 15px;
                a {
                    color: $text-color2;
                    i{
                        color: $text-color3;
                    }
                    &:hover {
                        color: $color-b;
                    }
                }
            }
        }
    }
}
</style>
